import { useQuery } from 'react-query'
import { ContentDiscoveryClient, ContentDiscoveryResponse } from 'api/clients/ContentDiscoveryClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { reportError } from 'utils/error'
import { buildErrorMessage } from 'utils'

export const contentDiscoveryQueryKey = (workspaceId: number) =>
  ['workspaces', workspaceId, 'content_discovery'] as const

const fetchContentDiscovery = async (workspaceId: number): Promise<ContentDiscoveryResponse> => {
  const response = await ContentDiscoveryClient.get(workspaceId)

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError('Failed to fetch content discovery', { metaData: { response: response.data } })
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }

  return response.data
}

export const useContentDiscovery = () => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<ContentDiscoveryResponse, Error>(
    contentDiscoveryQueryKey(workspaceId),
    () => fetchContentDiscovery(workspaceId),
    {
      enabled: !!workspaceId,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
  )
}
